import { render, staticRenderFns } from "./NodesGroupChildren.vue?vue&type=template&id=2c89307b&lang=pug&"
import script from "./NodesGroupChildren.vue?vue&type=script&lang=js&"
export * from "./NodesGroupChildren.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports